import Logo from "@/components/icons/Logo";
import { cn } from "@/util/cn";
import { NavUserBuyPanels } from "../NavUserBuyPanels";
import BackButton from "../ui/BackButton";
import { useLocation, useNavigate } from "react-router";

export default function Header({
  className,
  mainLink,
}: {
  className?: string;
  mainLink?: string;
}) {
  const hasBag = false;
  const navigate = useNavigate();
  const location = useLocation();
  const backLabel = location.pathname.includes("ownership")
    ? "Continue Shopping"
    : "Back";

  const handleBack = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate(mainLink ?? "/");
  };

  return (
    <header className={className}>
      <nav
        className={cn(
          "mx-auto flex max-w-screen-xl items-center px-4 sm:px-6 lg:px-8 h-20 relative justify-center"
        )}
      >
        <div className="absolute left-4 top-1/2 transform -translate-y-1/2">
          <BackButton handleBack={handleBack} label={backLabel} />
        </div>

        <Logo className="h-8 sm:h-16" mainLink={mainLink} />
        {/* {hasBag && (
          <div>
            <button className="bg-brand-orange-500 py-2 px-4 rounded-full flex gap-2 text-brand-neutral-900 font-semibold cursor-pointer hover:scale-105 hover:underline">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-6 stroke-2 text-gray-900"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15.75 10.5V6a3.75 3.75 0 1 0-7.5 0v4.5m11.356-1.993 1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 0 1-1.12-1.243l1.264-12A1.125 1.125 0 0 1 5.513 7.5h12.974c.576 0 1.059.435 1.119 1.007ZM8.625 10.5a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm7.5 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
                />
              </svg>
              <span className="font-aladin font-normal">My Bag</span>
            </button>
          </div>
        )} */}
        <div className="absolute right-4 top-1/2 transform -translate-y-1/2">
          <NavUserBuyPanels />
        </div>
      </nav>
    </header>
  );
}
